export const SET_ADMIN_SCENARIOS_REQUEST = 'SET_ADMIN_SCENARIOS_REQUEST';
export const SET_ADMIN_SCENARIOS_SUCCESS = 'SET_ADMIN_SCENARIOS_SUCCESS';
export const SET_ADMIN_SCENARIOS_FAILED = 'SET_ADMIN_SCENARIOS_FAILED';
export const CLEAN_ADMIN_SCENARIOS = 'CLEAN_ADMIN_CLEAN_ADMIN_SCENARIOS';
